import api from '.';

const HotelLocations = (
  inputValue: string,
  callback: (options: any) => void
) => {
  api
    .get(`/search/get/goalsLocationHotels?query=${inputValue}`)
    .then(({ data }) => {
      if (!data.travelLocation) {
        callback([]);
      } else {
        callback(
          data.travelLocation.map((d: any) => ({
            value: d,
            label: d,
          }))
        );
      }
    });
};

export default HotelLocations;
